import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore" 
import { ArticleGW } from "./ArticleGW" 

///////////////   FavoritesDeleteView  ////////////////

/* FavoritesDeleteView is displayed when the user has clicked to delete a favorite. */

export interface FavoritesDeleteViewVm  {
    app: App,
    article: ArticleGW
}

export interface FavoritesDeleteViewStateVm {
    stage: string
}

// Project save view is displayed at the right hand side if the user attempts to save a project
export class FavoritesDeleteView extends React.Component<FavoritesDeleteViewVm, FavoritesDeleteViewStateVm> {
    state = {
        stage: "initial"
    }

    constructor(props: FavoritesDeleteViewVm) {
        super(props)
    }

    componentWillMount() {
        this.props.app.GetCore().ConnectFavoritesDeleteView(this)
    }
    
    OnCansel() {
        this.props.app.setState({ DisplayMode: this.props.app.DMode.Favorites })
    }

    OnDelete() {
        this.props.app.GetCore().FavoritesRemove(this.props.article.GetArticleID())
        this.props.app.setState({ DisplayMode: this.props.app.DMode.Favorites })
    }

    OnCheck() {
    }

    render() {
        // Checks if the user wants to overwrite a saved project with the identical name
        if (this.state.stage == "initial") {
            var favStr = "url(images/ItemFavoritesIcon.png)"
            var iconPosX = "-62px"
            var iconPosY = "-31px"

            if (this.props.app.GetCore().WillAskDeleteFavoritesQuestion() == true) {
                iconPosX = "-93.3px"
            }
            
            const bgPositionFav = iconPosX + " " + iconPosY

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column", marginBottom:"9px" }}>
                    <div>Er du sikker på at du vil fjerne:</div>
                    <div style={{ color: "#335588", marginTop: "9px"}}>{this.props.article.GetDescription()}</div>
                    <div style={{color:"#335588"}}>{this.props.article.GetDescription2()}</div>
                    <div style={{ marginTop:"9px"}}>fra favoritter?</div>

                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnDelete.bind(this)} style={{ backgroundColor: "grey", width: "64px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Fjern
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left:"20px",cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>

                    <div style={{ position: "relative", top: "90px", display: "flex", flexDirection: "row" }}>
                        <div style={{
                            width: "32px",
                            height: "32px",
                            cursor: "pointer",
                            position: "relative",
                            left:"-10px",
                            backgroundImage: favStr,
                            backgroundPosition: bgPositionFav
                        }} onClick={this.onClickHideQuestion.bind(this)}></div>

                        <div style={{position:"relative", top:"10px"}}>Ikke vis dette spørsmålet i fortsettelsen</div>
                    </div>
                </div>
            </div>
        }
        
        return <div>(delete favorite view)</div>
    }

    onClickHideQuestion() {
        this.props.app.GetCore().ToggleAskingDeleteFavoritesQuestion()
        this.forceUpdate()
    }
}



// WEBPACK FOOTER //
// ./client/view/FavoritesDeleteView.tsx